import { render } from "./ConfirmBox.vue?vue&type=template&id=f64c1f76"
import script from "./ConfirmBox.vue?vue&type=script&lang=js"
export * from "./ConfirmBox.vue?vue&type=script&lang=js"

import exportComponent from "d:\\WinNMP\\WWW\\dapodik\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__